import { createRestClient } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'
// import { useSuspenseQuery } from '@tanstack/react-query'
// import { menuData } from '@/unity-apps/mock-data/menu.json'
const { getLandingApiGetPlatformOperations } = createRestClient()

export function useGetAppMenu() {
  const appId = useGetSearchParam<number>('appId')
  const projectId = useGetSearchParam<number>('projectId')
  return getLandingApiGetPlatformOperations.useSuspenseQuery({ query: { appId, projectId, grouping: 'menu' } })
  // return useSuspenseQuery({
  //   queryKey: ['getLandingApiGetPlatformOperations', { appId, projectId, grouping: 'menu' }],
  //   queryFn: async () => {
  //     const data = new Promise((res) => {
  //       setTimeout(() => res(menuData), 1000)
  //     })
  //     return (await data) as typeof menuData
  //   },
  // })
}
